import { Box } from '@chakra-ui/react';
import ContractsList from './ContractsList';
import Header from './Header';

function Contracts() {
  return (
    <Box p={8}>
      <Header />
      <ContractsList />
    </Box>
  );
}
export default Contracts;
